
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.514 4.522l.01.014s.676.416 2.028.416c1.352 0 2.028-.416 2.028-.416l.008-.012L9.996 14H5.004l.51-9.478zm3.878-.609h.604l-.416.572s-.676.416-2.028.416c-1.352 0-2.028-.416-2.028-.416l-.416-.572h.5c.41.13 1.034.26 1.892.26.858 0 1.482-.13 1.892-.26zm-.099-.979h1.223l-.52.676s-.78.52-2.496.52-2.496-.52-2.496-.52l-.52-.676h1.223a7.318 7.318 0 001.793.208c.745 0 1.341-.094 1.793-.208zm-.405-1.247h2.096l-.624.78s-.936.624-2.86.624-2.86-.624-2.86-.624l-.624-.78h2.2c.328.084.774.156 1.336.156s1.008-.072 1.336-.156zM9.996.813l-.416.572s-.676.416-2.028.416c-1.352 0-2.028-.416-2.028-.416l-.52-.572h4.992z"}})])
          )
        }
      }
    